export interface ICellPhoneInputFormValues {
    phoneCell: string;
    smsOptInStatus: SmsOptInStatus;
    verificationRequest: VerificationMessageType;
}

export enum SmsOptInStatus {
    None = 0,
    RequestedOptIn = 5,
    OptedIn = 10,
    RequestedOptOut = 15,
    OptedOut = 20,
}

export enum VerificationMessageType {
    None = 0,
    OptIn = 1,
    OptOut = 2,
}
